export const validationMessage = {
    genderValidation: "Please select gender",
    titleValidation: "Please select title",
    firstNameValidation: "Please enter first name",
    surnameValidation: "Please enter surname",
    emailValidation: "Please enter email address",
    dateOfBirthValidation: "Please select date of birth",
    dateOfBirthCurrentDateValidation: "Please select date before current date",
    adviserValidation: "Please select adviser",
    clientTypeValidation: "Please select client type",
    firmValidation: "Please select firm",
    networkValidation: "Please select network",
    landlienNumberValidation: "Invalid landline phone number entered"
};
